<template>
  <div class="app-shell">
    <div v-if="showNavbar" id="wrapper" class="app-layout">
      <nav class="navbar-default navbar-static-side app-sidebar" role="navigation">
        <div class="sidebar-collapse">
          <div class="nav-header">
            <router-link class="navbar-logo" to="/home">
              <img src="../../assets/img/IDS_Logo.png" alt="IDS Admin" />
            </router-link>
          </div>

            <ul id="side-menu" class="nav side-menu">
            <li class="side-menu__section-label">Main</li>

            <li :class="{ active: route.name === 'Home' }" class="w-100">
              <router-link to="/home" class="nav-link">
                <i class="fa fa-home menu-icon-fa"></i>
                <span class="nav-label">Home</span>
              </router-link>
            </li>

            <li :class="{ active: route.name === 'Orgnization' }" class="w-100">
              <router-link to="/organization" class="nav-link">
                <i class="fa fa-building menu-icon-fa"></i>
                <span class="nav-label">Organization</span>
                <!-- <span class="nav-badge">4</span> -->
              </router-link>
            </li>

            <li :class="{ active: route.name === 'Tenant' }" class="w-100">
              <router-link to="/tenant" class="nav-link">
                <i class="fa fa-user menu-icon-fa"></i>
                <span class="nav-label">Tenant</span>
              </router-link>
            </li>

            <li :class="{ active: route.name === 'Roles' }" class="w-100">
              <router-link to="/roles" class="nav-link">
                <i class="fa fa-key menu-icon-fa"></i>
                <span class="nav-label">Roles & Access</span>
              </router-link>
            </li>

            <li class="side-menu__section-label">App Catalog</li>

            <li :class="{ active: route.name === 'AdminModules' }" class="w-100">
              <router-link to="/adminmodules" class="nav-link">
                <!-- <i class="fa-regular fa-file-lines menu-icon-fa"></i> -->
                 <i class="fas fa-cubes"></i>
                <span class="nav-label">App Modules</span>
              </router-link>
            </li>

            <li :class="{ active: route.name === 'AppResource' }" class="w-100">
              <router-link to="/appresource" class="nav-link">
                <i class="fa-regular fa-file-lines menu-icon-fa"></i>
                <span class="nav-label">App Resources</span>
              </router-link>
            </li>

            <li :class="{ active: route.name === 'Connections' }" class="w-100">
              <router-link to="/connections" class="nav-link">
                <i class="fa fa-database menu-icon-fa"></i>
                <span class="nav-label">Connections</span>
              </router-link>
            </li>

            <li :class="{ active: route.name === 'AuditLogs' }" class="w-100">
              <router-link to="/audit-logs" class="nav-link">
                <i class="fa fa-history menu-icon-fa"></i>
                <span class="nav-label">Audit Logs</span>
              </router-link>
            </li>

            <li :class="{ active: route.name === 'Settings' }" class="w-100">
              <router-link to="/settings" class="nav-link">
                <i class="fa fa-gear menu-icon-fa"></i>
                <span class="nav-label">Settings</span>
              </router-link>
            </li>
          </ul>
        </div>
      </nav>

      <div id="page-wrapper" class="gray-bg app-page">
        <nav class="navbar navbar-static-top app-topbar" role="navigation">
          <div class="app-topbar__title">IDS Admin</div>

          <button type="button" class="app-topbar__logout" @click="logout">
            Logout
          </button>
        </nav>

        <router-view />
      </div>
    </div>

    <div v-else class="app-content app-content--login">
      <router-view />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "Navbar",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const showNavbar = computed(
      () => store.getters.authenticated && route.name !== "login"
    );

    async function logout() {
      await store.dispatch("logoutuser");
      await store.dispatch("setNavbar", false);
      await router.push({ name: "login" });
    }

    return {
      route,
      showNavbar,
      logout,
    };
  },
};
</script>

<style scoped>
.app-shell {
  height: 100vh;
  background: #f5f7fb;
  overflow: hidden;
}

/* ── Section labels ── */
.side-menu__section-label {
  padding: 18px 20px 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.2);
  pointer-events: none;
}

/* ── FA icons in nav ── */
.menu-icon-fa {
  font-size: 14px;
  width: 18px;
  text-align: center;
  flex-shrink: 0;
}

.nav-badge {
  margin-left: auto;
  background: #19aa8d;
  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 20px;
  min-width: 18px;
  text-align: center;
}

.app-layout {
  height: 100vh;
  display: flex;
  background: #f5f7fb;
}

.app-sidebar {
  width: 230px;
  height: 100vh;
  flex: 0 0 230px;
  background: #2f4050;
  color: #a7b1c2;
  overflow-y: auto;
}

.sidebar-collapse {
  min-height: 100%;
}

.nav-header {
  height: 53px;
  display: flex;
  align-items: center;
  padding: 12px 18px;
  background: #f5f7fb;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.navbar-logo {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.navbar-logo img {
  max-width: 150px;
  max-height: 34px;
  object-fit: contain;
}

.side-menu {
  list-style: none;
  margin: 0;
  padding: 12px 0;
}

.side-menu li {
  margin: 0;
}

.side-menu li.active {
  border-left: 4px solid #19aa8d;
  background: #293846;
}

.side-menu .nav-link {
  min-height: 46px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: #a7b1c2;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 0;
}

.side-menu li.active .nav-link,
.side-menu .nav-link:hover,
.side-menu .nav-link:focus {
  color: #ffffff;
  background: #293846;
}

.menu-icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 12px;
  line-height: 1;
}

.app-page {
  min-width: 0;
  height: 100vh;
  flex: 1;
  background: #f5f7fb;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.app-topbar {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: #ffffff;
  border-bottom: 1px solid #e7eaec;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  flex-shrink: 0;
}

.app-topbar__title {
  color: #2f4050;
  font-size: 16px;
  font-weight: 700;
  margin-left: 20px;
}

.app-topbar__logout {
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 6px 14px;
  background: #ffffff;
  color: #374151;
  font-size: 14px;
  line-height: 1.2;
  cursor: pointer;
  margin-left: 20px;
}

.app-topbar__logout:hover,
.app-topbar__logout:focus {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.app-content--login {
  min-height: 100vh;
}

@media (max-width: 768px) {
  .app-layout {
    display: block;
  }

  .app-sidebar {
    width: 100%;
    min-height: auto;
    flex: none;
  }

  .nav-header {
    height: 53px;
  }

  .side-menu {
    display: flex;
    padding: 0;
  }

  .side-menu li {
    flex: 1;
  }

  .side-menu li.active {
    border-left: 0;
    border-bottom: 3px solid #19aa8d;
  }

  .side-menu .nav-link {
    justify-content: center;
    padding: 10px 12px;
  }

  .app-topbar {
    padding: 0 14px;
  }
}
</style>
